import { render, staticRenderFns } from "./OrderImage.vue?vue&type=template&id=5f070da8&scoped=true&"
import script from "./OrderImage.vue?vue&type=script&lang=js&"
export * from "./OrderImage.vue?vue&type=script&lang=js&"
import style0 from "./OrderImage.vue?vue&type=style&index=0&id=5f070da8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f070da8",
  null
  
)

export default component.exports